import $api from './instance';

export const resetEmailConfirmation = (email: string) => {
  return $api.post('/developer/reset-email-confirmation', { email });
};

export const deleteUser = (email: string) => {
  return $api.delete('/developer/user', { data: { email } });
};

export const getEnvVariables = () => {
  return $api.get('/developer/env');
};
